import AnalyticsNavItems from '@/analytics/main/AnalyticsNavItems';
import CertPermNavItems from '@/certperm/main/CertPermNavItems';
import CrmNavItems from '@/crm/main/CrmNavItems';
import DashboardNavItems from '@/dashboard/main/DashboardNavItems';
import EmployeesNavItems from '@/employees/main/EmployeesNavItems';
import EquipmentNavItems from '@/equipments/main/EquipmentNavItems';
import JobsNavItems from '@/jobs/main/JobsNavItems';
import { NavItemType } from '../type';
import RaptorJobNavItems from '@/raptorjob/main/RaptorJobNavItems';
import SalesNavItems from '@/customers/main/SalesNavItems';
import SidebarNavGroup from './SidebarNavItemGroup';
import TimesheetsNavItems from '@/timesheets/main/TimesheetsNavItems';
import UserManagementNavItems from '@/userManagement/main/UserManagementNavItems';
import Typography from '@mui/material/Typography';
import { memo, useMemo } from 'react';

const SidebarNavItems = () => {
  const jobsNavResult = JobsNavItems();
  const jobsNav = jobsNavResult.item;

  const salesNavResult = SalesNavItems();
  const salesNav = salesNavResult.item;

  const equipmentsNavResult = EquipmentNavItems();
  const equipmentsNav = equipmentsNavResult.item;

  const employeesNavResult = EmployeesNavItems();
  const employeesNav = employeesNavResult.item;

  const analyticsNavResult = AnalyticsNavItems();
  const analyticsNav = analyticsNavResult.item;

  const dashboardNavResult = DashboardNavItems();
  const dashboardNav = dashboardNavResult.item;

  const timesheetsNavResult = TimesheetsNavItems();
  const timesheetsNav = timesheetsNavResult.item;

  const raptorJobNavResult = RaptorJobNavItems();
  const raptorJobNav = raptorJobNavResult.item;

  const certPermNavResult = CertPermNavItems();
  const certPermNav = certPermNavResult.item;

  const userManagementNavResult = UserManagementNavItems();
  const userManagementNav = userManagementNavResult.item;

  const crmNavResult = CrmNavItems();
  const crmNav = crmNavResult.item;

  // Only render when all nav items with feature flags are ready
  const isReady = useMemo(() => {
    return (
      jobsNavResult.isReady &&
      salesNavResult.isReady &&
      equipmentsNavResult.isReady &&
      employeesNavResult.isReady &&
      analyticsNavResult.isReady &&
      dashboardNavResult.isReady &&
      timesheetsNavResult.isReady &&
      raptorJobNavResult.isReady &&
      certPermNavResult.isReady &&
      userManagementNavResult.isReady &&
      crmNavResult.isReady
    );
  }, [
    jobsNavResult.isReady,
    salesNavResult.isReady,
    equipmentsNavResult.isReady,
    employeesNavResult.isReady,
    analyticsNavResult.isReady,
    dashboardNavResult.isReady,
    timesheetsNavResult.isReady,
    raptorJobNavResult.isReady,
    certPermNavResult.isReady,
    userManagementNavResult.isReady,
    crmNavResult.isReady
  ]);

  const menuItems: { items: NavItemType[] } = {
    items: [
      {
        id: 'dashboard',
        type: 'group',
        children: [
          dashboardNav,
          jobsNav,
          raptorJobNav,
          salesNav,
          equipmentsNav,
          employeesNav,
          analyticsNav,
          timesheetsNav,
          certPermNav,
          userManagementNav,
          crmNav
        ].filter((n): n is NavItemType => Boolean(n))
      }
    ]
  };

  // Don't render menu items until feature flags are ready to avoid showing/hiding items after initial render
  if (!isReady) {
    return null;
  }

  let lastItemIndex = menuItems.items?.length - 1;

  return menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    if (item.type === 'group') {
      return <SidebarNavGroup key={item.id} item={item} />;
    }

    return (
      <Typography key={item.id} variant="h6" color="error" align="center">
        Menu Items Error
      </Typography>
    );
  });
};

export default memo(SidebarNavItems);
